// Central data for VIL Engineering website

export const COMPANY = {
    name: "VIL Engineering",
    short: "VIL",
    tagline: "Complete Fire Protection & Life Safety Solutions",
    subtitle:
        "Licensed Fire Fighting, Sprinkler, Detection & Suppression System Experts",
    address: "VIL Engineering, 1st floor, 06, C Wing, GIRIRAJ BUILDING, Kacheri Road, Opp. Congress Bhawan, Vishnu Nagar, Palghar,  Maharashtra 401404",
    city: "VIL Engineering, 1st floor, 06, C Wing, GIRIRAJ BUILDING, Kacheri Road, Opp. Congress Bhawan, Vishnu Nagar, Palghar,  Maharashtra 401404",
    emails: [
        "info@vilengineering.com",
    ],
    primaryEmail: "info@vilengineering.com",
    contacts: [
        {
            name: "Sharvil Raut",
            role: "Proprietor",
            phone: "+91 7822002125",
            phoneRaw: "917822002125",
        },
        {
            name: "Vinit Patil",
            role: "Proprietor",
            phone: "+91 8412986278",
            phoneRaw: "918412986278",
        }
    ],
    whatsapp: "917822002125",
    primaryPhone: "+91 7822002125",
    primaryPhoneRaw: "917822002125",
    licenses: ["Licensed – Fire Fighting & Sprinkler", "Licensed – Detection & Fire Suppression"],
};

export const STATS = [
    { value: 100, suffix: "+", label: "Projects Completed" },
    { value: 120, suffix: "+", label: "Industrial Clients" },
    { value: 18, suffix: "+", label: "Ongoing Projects" },
    { value: 12, suffix: "+", label: "Years of Expertise" },
    { value: 500, suffix: "+", label: "Safety Installations" },
];

export const TRUST_BADGES = [
    { label: "Licensed Fire Safety Agency", icon: "ShieldCheck" },
    { label: "Government Compliance", icon: "BadgeCheck" },
    { label: "Industrial Expertise", icon: "Factory" },
    { label: "Fast Installation", icon: "Zap" },
    { label: "24/7 Support", icon: "Headphones" },
    { label: "Certified Engineers", icon: "Award" },
];

export const SERVICES = [
    {
        slug: "fire-fighting-systems",
        title: "Fire Hydrant System Installation",
        short: "End-to-end fire fighting infrastructure for industrial & commercial sites.",
        icon: "Flame",
        theme: "red",
        bullets: [
            "Licensed installations",
            "Complete pipework & hydraulic design",
            "Compliance with NBC & state norms",
        ],
        image: "https://fuller-eg.com/wp-content/uploads/2021/03/conreoltap-fire-system-5-scaled-1.jpg",
    },
    {
        slug: "fire-sprinkler-systems",
        title: "Fire Sprinkler Systems",
        short: "Wet, dry & deluge sprinkler systems engineered for hazard class.",
        icon: "Droplets",
        theme: "blue",
        bullets: ["Wet & dry pipe sprinklers", "Deluge & pre-action systems", "Hydraulic calculation reports"],
        image: "https://1973249.fs1.hubspotusercontent-na1.net/hubfs/1973249/Water_Supply_Factors.jpg",
    },
    {
        slug: "fire-alarm-systems",
        title: "Fire Alarm Systems",
        short: "Addressable & conventional fire detection with integrated panels.",
        icon: "Siren",
        theme: "red",
        bullets: ["Addressable & conventional panels", "Smoke & heat detector networks", "Integration with BMS"],
        image: "https://fudsinternational.com/cdn/shop/articles/Fire_alarm_system_3.jpg?v=1746792201&width=1100",
    },
    //{
     //   slug: "fire-suppression-systems",
     //   title: "Fire Suppression Systems",
     //   short: "Clean agent, CO2 & kitchen suppression for high-value assets.",
     //   icon: "ShieldAlert",
     //   theme: "red",
     //   bullets: ["Clean agent (FM-200, Novec)", "CO2 flooding systems", "Kitchen hood suppression"],
     //   image: "https://5.imimg.com/data5/SELLER/Default/2024/6/425798026/JF/HT/VP/75452602/fire-suppression-system-for-server.jpg",
     // },
     //  {
     //   slug: "pump-room-solutions",
     //   title: "Pump Room Solutions",
     //   short: "Complete pump room design, supply & commissioning.",
     //   icon: "Wrench",
     //   theme: "blue",
     //   bullets: ["Electric & diesel pump sets", "Jockey pump configuration", "Pressure switch automation"],
     //   image: "https://gulffire.com/wp-content/uploads/2023/04/Armstrong-1.jpg",
    //},
    {
        slug: "fire-hydrant-accessories",
        title: "Fire Hydrant Accessories",
        short: "Hydrant valves, hoses, branches & landing valves supply.",
        icon: "PipetteIcon",
        theme: "blue",
        bullets: ["BS-336 / IS-marked hydrants", "RRL hose pipes & branches", "Hose boxes & cabinets"],
        image: "https://firesafetypoint.com/wp-content/uploads/2020/02/Fire-Hydrant-Accessories.jpg",
    },
    //{
    //    slug: "public-addressable-systems",
    //    title: "Public Addressable Systems",
    //      short: "Mass notification & evacuation audio for large facilities.",
    //    icon: "Volume2",
    //    theme: "red",
    //    bullets: ["Zonal audio paging", "Emergency voice evacuation", "Integration with fire panel"],
    //    image: "https://5.imimg.com/data5/VM/BQ/CC/SELLER-23168374/fire-alarm-systems-500x500.jpg",
    //},
    {
        slug: "amc-maintenance",
        title: "AMC & Maintenance",
        short: "Comprehensive AMC, periodic testing & compliance reports.",
        icon: "Settings",
        theme: "blue",
        bullets: ["Quarterly preventive maintenance", "Hydrostatic & flow testing", "Statutory compliance audits"],
        image: "https://5.imimg.com/data5/SELLER/Default/2023/5/310388553/NK/EX/XR/151447218/fire-safety-equipment-maintenance-services-500x500.jpg",
    },
    {
        slug: "fire-safety-consultancy",
        title: "Fire Safety Consultancy",
        short: "Design review, audits & NOC documentation support.",
        icon: "ClipboardCheck",
        theme: "red",
        bullets: ["Fire safety audits", "Drawing & approval support", "Risk assessment & gap analysis"],
        image: "https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img/https://mmjss.com/wp-content/uploads/2025/07/Fire-Fighting-Companies-in-Dubai3.jpg",
    },
];

export const WHY_US = [
    { title: "Licensed Fire Safety Agency", desc: "Authorized for Fire Fighting, Sprinkler, Detection & Suppression installations.", icon: "BadgeCheck", theme: "red" },
    { title: "Certified Engineers", desc: "Field-trained technical team with deep system commissioning experience.", icon: "Award", theme: "red" },
    { title: "End-to-End Execution", desc: "Design, supply, installation, testing, and AMC under one roof.", icon: "Workflow", theme: "blue" },
    { title: "Fast Mobilization", desc: "Rapid site response for inspection, quotation, and project kick-off.", icon: "Zap", theme: "red" },
    { title: "Quality Products", desc: "We source only IS / UL / FM-marked components from trusted OEMs.", icon: "ShieldCheck", theme: "blue" },
    { title: "Maintenance Support", desc: "Long-term AMC contracts with quarterly preventive servicing.", icon: "Settings", theme: "blue" },
];

export const PRODUCTS = [
    {
        id: "p1",
        name: "ABC Dry Powder Fire Extinguisher 6kg",
        category: "Fire Extinguishers",
        spec: "ISI marked · IS 15683 · Squeeze-grip",
        image: "https://images.unsplash.com/photo-1595306394931-b35768661692?auto=format&fit=crop&w=900&q=80",
    },
    {
        id: "p2",
        name: "Pendant Sprinkler Head 68°C",
        category: "Sprinklers",
        spec: "UL Listed · 1/2\" NPT · K-5.6",
        image: "https://5.imimg.com/data5/NU/MY/MY-3757173/fire-sprinkler-1000x1000.jpg",
    },
    {
        id: "p4",
        name: "Photoelectric Smoke Detector",
        category: "Smoke Detectors",
        spec: "Addressable · UL/EN54-7 · 24VDC",
        image: "https://5.imimg.com/data5/SELLER/Default/2025/2/485574730/KL/AT/IW/184060416/photoelectric-smoke-detection-system-for-fire-fighting-1000x1000.jpeg",
    },
    {
        id: "p5",
        name: "Hydrant Landing Valve 63mm SS",
        category: "Hydrant Valves",
        spec: "IS 5290 · Stainless steel · Oblique",
        image: "https://images.unsplash.com/photo-1530475278652-5d941f9daa08?auto=format&fit=crop&w=900&q=80",
    },
    {
        id: "p8",
        name: "Industrial Safety Helmet Kit",
        category: "Safety Equipment",
        spec: "ANSI Z89.1 · Chin strap · Visor",
        image: "https://blazeguardfire.in/wp-content/uploads/2025/08/protection-kit.webp",
    },
    {
        id: "p9",
        name: "CO2 Fire Extinguisher 4.5kg",
        category: "Fire Extinguishers",
        spec: "ISI marked · IS 15683 · Class B & C",
        image: "https://static1.industrybuying.com/products/safety/fire-safety/fire-extinguishers/SAF.FIR.138399270_1770974778797.webp",
    },
    {
        id: "p10",
        name: "Manual Call Point (Break Glass)",
        category: "Fire Alarm Panels",
        spec: "Addressable · Weatherproof · IP54",
        image: "https://5.imimg.com/data5/UB/BV/MY-42337944/break-glass-manual-call-point-1000x1000.jpg",
    },
    {
        id: "p11",
        name: "Hose Reel Drum with Nozzle 30m",
        category: "Hose Reels",
        spec: "Swing-arm · 19mm · IS 884",
        image: "https://static1.industrybuying.com/products/hydraulics-and-pneumatics/hoses-hose-fittings/hydraulic-hose-and-reel/hose-reels/HYD.HOS.937053240_1767940045301.webp",
    }
];

export const PRODUCT_CATEGORIES = [
    "All",
    "Fire Extinguishers",
    "Sprinklers",
    "Fire Alarm Panels",
    "Smoke Detectors",
    "Hydrant Valves",
    "Fire Pumps",
    "Hose Reels",
    "Safety Equipment",
];

export const INDUSTRIES = [
    { name: "Hospitals", image: "https://images.unsplash.com/photo-1586773860418-d37222d8fce3?auto=format&fit=crop&w=1200&q=80" },
    { name: "Schools & Colleges", image: "https://images.unsplash.com/photo-1580582932707-520aed937b7b?auto=format&fit=crop&w=1200&q=80" },
    { name: "Warehouses", image: "https://images.unsplash.com/photo-1553413077-190dd305871c?auto=format&fit=crop&w=1200&q=80" },
    { name: "Manufacturing Units", image: "https://images.unsplash.com/photo-1565793298595-6a879b1d9492?auto=format&fit=crop&w=1200&q=80" },
    { name: "Commercial Complexes", image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1200&q=80" },
    { name: "Residential Towers", image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=1200&q=80" },
    { name: "Government Projects", image: "https://www.consultancy.in/illustrations/news/spotlight/2023-08-08-085454549-BCG_and_McKinsey_advising_government_on_digital_infrastructure_reform_spot.jpg" },
    { name: "MIDC Industries", image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=1200&q=80" },
];

export const PROJECTS_COMPLETED = [
    {
        name: "Shatabdi Hospital",
        location: "Govandi, Mumbai",
        type: "Healthcare",
        image: "/project_images/shatabdi-hospital.jpg",
    },
    {
        name: "District Headquarters of Palghar",
        location: "Palghar",
        type: "Government",
        image: "/project_images/palghar-district.jpg",
    },
    {
        name: "Raychem RPG",
        location: "Vasai",
        type: "Manufacturing",
        image: "/project_images/raychem-rpg.jpg",
    },
    {
        name: "Gujarat Gas Ltd",
        location: "Boisar",
        type: "Industrial",
        image: "/project_images/gujrat-gas.avif",
    },
    {
        name: "NMSEZ Jio Institute",
        location: "Ulwe",
        type: "Education",
        image: "/project_images/jio-institute.png",
    },
    {
        name: "Emerald Isle Tower-15, L&T",
        location: "Powai, Mumbai",
        type: "Residential",
        image: "/project_images/landt-tower.avif",
    },
    {
        name: "Aarati Drugs Ltd",
        location: "Tarapur MIDC",
        type: "Pharma",
        image: "/project_images/Aarti_Drugs.png",
    },
    {
        name: "Vasundhara Dairy (Amul)",
        location: "Gujarat",
        type: "Food & Beverage",
        image: "/project_images/vasurndhara-dairy-.png",
    },
    {
        name: "Crescent Point II",
        location: "MMR",
        type: "Residential",
        image: "/project_images/cresent-point-ii.webp",
    },
    {
        name: "Raychem RPG Pvt Ltd",
        location: "Vasai",
        type: "Manufacturing",
        image: "/project_images/raychem-rpg.jpg",
    },
    {
        name: "Linit Exports Pvt Ltd",
        location: "MIDC",
        type: "Industrial",
        image: "/project_images/Linit Exports Pvt Ltd.jpg",
    },
    {
        name: "KAVITA RIBBONS & TEXTILES LLP",
        location: "TAMSAI, MANOR",
        type: "Industrial",
        image: "/project_images/text-tile-img.webp",
    },
    {
        name: "PARSHWANATH 9 BLDG",
        location: "BIDCO, PALGHAR",
        type: "Industrial",
        image: "/project_images/PARSHWANATH.webp",
    },
    {
        name: "KUMARAM SPORTS (TENNEX) C-4/2(1)",
        location: "TARAPUR MIDC",
        type: "Industrial",
        image: "/project_images/SPORTS-PALNT.jpg",
    },     
];

export const PROJECTS_ONGOING = [
    {
        name: "Shri Chaitanya School",
        location: "Maharashtra",
        type: "Education",
        image: "/project_images/01_Shri Chaitanya School.png",
    },
    {
        name: "Primeware Hygiene India Pvt Ltd",
        location: "MIDC",
        type: "Manufacturing",
        image: "/project_images/prime-ware.webp",
    },
    {
        name: "KMS Manufacturing Company",
        location: "Tarapur",
        type: "Industrial",
        image: "/project_images/kms.jpg",
    },
    {
        name: "Teen World Corporate School",
        location: "Palghar",
        type: "Education",
        image: "/project_images/shree-chaitanya-school.jpg",
    },
    {
        name: "Civil Court Building CIDCO",
        location: "CIDCO",
        type: "Government",
        image: "/project_images/cidco.jpg",
    },
    {
        name: "VALCOUR HOUSEWARE LLP",
        location: " TAMSAI, MANOR",
        type: "Government",
        image: "/project_images/raychem-rpg.jpg",
    },
    {
        name: "OZPURE FNB PVT LTD",
        location: "KANCHAD, WADA",
        type: "Government",
        image: "/project_images/plant-.jpg",
    },
    {
        name: "KK CENTRAL PARK (VIJAY SALES)",
        location: "PALGHAR (W)",
        type: "Government",
        image: "/project_images/kk-central-park.avif",
    },     
];

export const TESTIMONIALS = [
    {
        quote:
            "VIL Engineering executed our sprinkler and hydrant system ahead of schedule. Their compliance documentation made our final NOC seamless.",
        author: "Plant Manager",
        company: "Amul",
    },
    {
        quote:
            "Highly professional team. From design walkthrough to final commissioning, every milestone was met with precision and clean execution.",
        author: "Project Lead",
        company: "INOX",
    },
    {
        quote:
            "Their AMC team is responsive and thorough. Quarterly preventive maintenance reports are detailed and audit-ready every single time.",
        author: "Facility Head",
        company: "Shatabdi Hospital",
    },
    {
        quote:
            "We trusted VIL with a government-grade facility and they delivered turnkey fire protection with zero compliance gaps.",
        author: "Project Officer",
        company: "CIDCO",
    },
];

export const HERO_IMAGE =
    "https://customer-assets.emergentagent.com/job_vil-fire-safety/artifacts/xdg3kczx_image.png";

export const ABOUT_IMAGE =
    "https://images.pexels.com/photos/8961146/pexels-photo-8961146.jpeg?auto=compress&cs=tinysrgb&w=1400";

export const CLIENT_LOGOS = [
    {
        name: "Raychem RPG",
        domain: "raychemrpg.com",
        logo: "/logos/raychemn_rpg.png",
    },
    {
        name: "Gujarat Gas",
        domain: "gujaratgas.com",
        logo: "/logos/gujrat-gas.webp",
    },
    {
        name: "Larsen & Toubro",
        domain: "larsentoubro.com",
        logo: "/logos/Larsen-Toubro.png",
    },
    {
        name: "Amul",
        domain: "amul.com",
        logo: "/logos/amul.png",
    },
    {
        name: "Jio Institute",
        domain: "jioinstitute.edu.in",
        logo: "/logos/Jio_Institue_Logo.png",
    },
    {
        name: "Aarati Drugs",
        domain: "aaratidrugs.com",
        logo: "/logos/aarati-drugs.jpg",
    },
    {
        name: "CIDCO",
        domain: "cidco.maharashtra.gov.in",
        logo: "/logos/cidco.jpg",
    },
    {
        name: "Shatabdi Hospital",
        domain: "shatabdihospital.in",
        logo: "/logos/shatabdi-hospital.avif",
    },
];
